<template>
    <div class="w-full flex flex-row px-3 py-2 cursor-pointer" @click="popup=true" style="min-height:50px">
        <div class="flex mr-3 align-items-center">
            <Avatar class="text-600" size="small" icon="pi pi-lock" shape="circle"/>
        </div>
        <div class="flex flex-1 justify-content-left align-items-center">
            <span class="text-600">******</span>
        </div>
        <div class="flex justify-content-right align-items-center">
            <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
        </div>
    </div>
    
    <Dialog class="w-full surface-100 border-none" modal 
        v-model:visible="popup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ lang('password_link_title') }}</span>
        </template>

        <div class="w-full flex h-full flex-column gap-3">
            <div class="w-full flex flex-column gap-2">
                <span class="flex text-sm text-600">{{ lang('password')}}:</span>
                <div class="flex p-float-label w-full">
                    <Password id="pass1" v-model="v$.pass1.$model" :class="{'p-invalid':v$.pass1.$invalid && pass1Length>0}" 
                        class="w-full border-2 border-round-xl surface-border overflow-hidden"
                        :promptLabel="lang('passpromptLabel')" :weakLabel="lang('passweakLabel')" :mediumLabel="lang('passmediumLabel')" :strongLabel="lang('passstrongLabel')"
                        toggleMask size="large"/>
                </div>
            </div>
             <div class="w-full flex flex-column gap-2">
                <span class="flex text-sm text-600">{{ lang('password_confirm')}}:</span>
                <div class="p-float-label w-full">
                    <Password id="pass2" v-model="v$.pass2.$model" :class="{'p-invalid':v$.pass2.$invalid && pass2Length>0}" :feedback="false"  
                        class="w-full border-2 border-round-xl surface-border overflow-hidden" toggleMask size="large"/>
                </div>
                <div class="w-full h-2rem">
                    <small v-if="pass1Length && pass2Length && ((v$.pass2.$invalid) || v$.pass2.$pending.$response)" class="text-red-500">
                        {{ content[lang_].invalid }}
                    </small>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="w-full flex flex-row gap-3">
                <Button type="submit" class="w-full border-round-xl" @click="updateUser()"
                    :label="lang('button_save')" :loading="loading" :disabled="!isValid || loading" size="large"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import { mapActions } from      "vuex"
import { useVuelidate } from    "@vuelidate/core"
import MobMenu from             '@/components/sides/menu/MobMenu.vue' 
import { email, required, sameAs, minLength, maxLength } from "@vuelidate/validators";

export default {
    data(){
        return {
            loading: false,
            pass1: null,
            pass2: null,
            popup: false,
            v$: useVuelidate(),

            content: {
                ru: {
                    invalid: 'Пароли не совпадают',
                },
                en: {
                    invalid: 'Passwords do not match',
                }
            }
        }
    },
    validations() {
        return {
            pass1: {
                required,
                minimunLength: minLength(5),
                maxLength: maxLength(30),
            },
            pass2: {
                required,
                sameAsPassword: sameAs(this.pass1)
            },
        }
    },
    components: {
        MobMenu
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
        pass1Length() { return this.v$.pass1.$model ? this.v$.pass1.$model.length : 0 },
        pass2Length() { return this.v$.pass2.$model ? this.v$.pass2.$model.length : 0 },
        isValid() {
            return this.v$.pass1.$pending === false && this.v$.pass2.$pending === false && this.v$.pass1.$invalid === false && this.v$.pass2.$invalid === false
        }
    },
    methods:{
        lang(value){
            return this.$t(`views.personal.profile.${value}`)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        ...mapActions(["ActionUpdUser"]),
        async updateUser() {
            if(!this.isValid) return
            this.loading = true

            let updData = {
                password: this.pass1,
            }

            try{
                const update = await this.ActionUpdUser(updData).then(res=>res)
                if(update.result && update.data) {
                    this.showMess('success', this.lang('mess_success'), this.lang('mess_success_text'))
                    this.loading = false
                    this.popup = false
                } else {
                    this.loading = false
                    if(update.errors) this.showMess('error', this.lang('mess_error'), update.errors[0])
                    else this.showMess('error', this.lang('mess_error'), this.lang('mess_error_text'))
                }
            } catch (e) {
                console.log(e)
                this.loading = false
                this.showMess('error', 'Error', 'Profile editing error')
            }
        },
    },
    created() {
        this.v$ = useVuelidate()
    },
}
</script>